//import axios from 'axios';
import http from './httpService';  
//import {apiUrl} from './../config/config.json';
const apiUrl = process.env.REACT_APP_API_URL;
const apiEndpoint = apiUrl+'/userroles';

// export async function getUserRoles(){
// const response = await http.get("http://localhost:4500/api/userRoles");
// return response;
//   }
  function userRoleUrl(id) {
    return `${apiEndpoint}/${id}`;
  }
  
  export function getUserRoles() {
    return http.get(apiEndpoint);
  }
  
  export function getUserRole(userRoleId) {
    return http.get(userRoleUrl(userRoleId));
  }
  
  export function saveUserRole(userRole) {
    //update
    if (userRole._id) {
      //clone userRole and delete _id
      const body = { ...userRole };
      delete body._id;
      return http.put(userRoleUrl(userRole._id), body);
    }
    //add a new userRole
    return http.post(apiEndpoint, userRole);
  }
  
  //delete userRoles
  export function deleteUserRole(userRoleId) {
    return http.delete(userRoleUrl(userRoleId));
  }  